// src/shared/utils/tableCode.js

/**
 * Table code normalizer
 *
 * UI 내부 screen id/volatileKey는 `table:${code}` 형태를 쓸 수 있지만,
 * 서버 socket payload의 tableCode/table_code는 raw table code만 사용해야 한다.
 *
 * 예:
 * - "ABC" -> "ABC"
 * - "table:ABC" -> "ABC"
 * - "table:table:ABC" -> "ABC"
 */
export function normalizeTableCode(value) {
  const s = String(value ?? '').trim();
  if (!s) return '';
  return s.replace(/^(table:)+/i, '').trim();
}

export function makeTableScreenId(value) {
  const code = normalizeTableCode(value);
  return code ? `table:${code}` : 'table:';
}

export function sameTableCode(a, b) {
  const aa = normalizeTableCode(a);
  const bb = normalizeTableCode(b);
  return !aa || !bb || aa === bb;
}
